/**
 * Page /petite-enfance/espace — Espace parent (vue citoyen) du module Petite Enfance.
 *
 * Conserve une entrée autonome (lien direct, interne d'un autre service…), mais
 * pour les ADMINISTRÉS le parcours unifié est /scolaire-cantine (brique famille
 * unique). Les sections sont mutualisées dans PetiteEnfanceEspaceSections.
 */

import { useState } from 'react';
import { AppHeader } from '@/components/AppHeader';
import { Alert, LogoMark, SectionEyebrow } from '@/components/ui';
import { Baby, AlertCircle } from 'lucide-react';
import { PetiteEnfanceEspaceSections } from '@/components/petite-enfance/PetiteEnfanceEspaceSections';

export default function PetiteEnfanceEspacePage() {
  const [error, setError] = useState<string | null>(null);

  return (
    <div className="min-h-screen text-ink">
      <AppHeader module="Petite enfance" accent="cantine" />
      <main id="main-content" className="mx-auto max-w-4xl px-4 py-5 sm:px-6 sm:py-8">
        <div className="mb-5 flex items-center gap-3">
          <LogoMark icon={Baby} accent="cantine" size="lg" />
          <div>
            <SectionEyebrow as="div">Espace famille</SectionEyebrow>
            <h1 className="mt-0.5 font-display text-xl font-semibold tracking-r-snug text-ink sm:text-2xl">Petite enfance</h1>
          </div>
        </div>

        {error && <Alert variant="error" icon={AlertCircle} className="mb-3">{error}</Alert>}

        <PetiteEnfanceEspaceSections setError={setError} />
      </main>
    </div>
  );
}
